import { ActionBase } from '../../../core/store/action/ActionBase';
import { MessagesModel } from '../../models/MessagesModel';

export const GET_MESSAGES_SUCCESS_ACTION = '[Configuration] Messages Get Messages Success Action';

export class GetMessagesSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_MESSAGES_SUCCESS_ACTION;

  constructor(public payload: { messages: MessagesModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/messages/store/actions/GetMessagesSuccessAction.ts